/*
 * lunna-footer-compact.js — o rodapé em sanfona no celular.
 *
 * As quatro colunas de links do rodapé ficam lado a lado no desktop e empilham
 * no celular: 25 links em coluna única, 1.024px, mais de uma tela inteira só de
 * navegação secundária depois do conteúdo ter acabado.
 *
 * A sanfona é montada aqui e não no Liquid de propósito. O Liquid renderiza a
 * mesma marcação para as duas larguras, então mexer nele significaria trocar o
 * DOM do desktop para resolver um problema que só existe no celular — e a
 * técnica usual (deixar o <details> fechado e forçá-lo aberto por CSS acima de
 * 750px) põe o desktop na dependência de uma folha de estilo carregar. Aqui o
 * desktop nunca chega a ver um <details>.
 *
 * Sem este script, o rodapé é exatamente o que sempre foi. A sanfona é um
 * acréscimo, nunca um requisito.
 */
(function () {
  'use strict';

  if (window.LunnaFooterCompact) return;
  window.LunnaFooterCompact = true;

  var CHEVRON = '<span class="lunna-footer-group__chevron" aria-hidden="true"></span>';
  var mq = window.matchMedia('(max-width: 749px)');
  var montados = [];

  function montar() {
    if (montados.length) return;

    document.querySelectorAll('.footer-block--menu').forEach(function (bloco) {
      var titulo = bloco.querySelector('.footer-block__heading');
      var lista = bloco.querySelector('.footer-block__details-content');
      if (!titulo || !lista) return;

      var caixa = document.createElement('details');
      caixa.className = 'lunna-footer-group';

      var resumo = document.createElement('summary');
      resumo.className = 'lunna-footer-group__summary';

      /* Guarda a posição original antes de mover nada: desfazer isto na
         virada para desktop precisa devolver os elementos ao lugar exato,
         e não simplesmente ao fim do bloco. */
      var ancora = titulo.nextSibling;

      bloco.insertBefore(caixa, titulo);
      resumo.appendChild(titulo);
      resumo.insertAdjacentHTML('beforeend', CHEVRON);
      caixa.appendChild(resumo);
      caixa.appendChild(lista);

      montados.push({ bloco: bloco, caixa: caixa, titulo: titulo, lista: lista, ancora: ancora });
    });
  }

  function desmontar() {
    montados.splice(0).forEach(function (m) {
      m.bloco.insertBefore(m.titulo, m.caixa);
      m.bloco.insertBefore(m.lista, m.caixa);
      var chevron = m.caixa.querySelector('.lunna-footer-group__chevron');
      if (chevron) chevron.remove();
      m.caixa.remove();
    });
  }

  function avaliar() {
    if (mq.matches) montar();
    else desmontar();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', avaliar);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(avaliar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avaliar);
  } else {
    avaliar();
  }

  // O editor de temas re-renderiza o rodapé sem recarregar a página.
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector('.footer-block--menu')) return;
    montados.length = 0;
    avaliar();
  });
})();
